import React from "react";

const StepIndicator = ({ stepNumber, lineWidth }) => {
  return (
    <div
      className="step-indicator"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // Center the circle and line within the parent container
        position: "relative",
      }}
    >
      {/* Circle with Number */}
      <div
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: "#FF0083",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "0.8rem",
          zIndex: 1, // Keep it above the line
        }}
      >
        {stepNumber}
      </div>

      {/* Right Line with dynamic width */}
      <div
        style={{
          width: lineWidth, // Use the passed width
          height: "1px",
          backgroundColor: "grey",
          position: "absolute",
          left: "50%", // Start the line from the middle of the circle
          top: "50%", // Center the line vertically with the circle
          transform: "translateX(15px)", // Offset the line to create space from the circle
          marginLeft: "5px", // Adds extra space between the circle and line
        }}
      />
    </div>
  );
};

export default StepIndicator;
